import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { DeviceButton2 } from '../components/DeviceButton';
import { transmitter } from '../actions/Transmitter';
import * as LWIcon from '../components/LWIcon';
import { isTransmitterDeviceState } from '../reducers/device_states';
export const DeviceButtonsHasta = props => {
    const devices = useAppSelector(state => state.definitions.devices);
    const device_states = useAppSelector(state => state.device_states);
    const dispatch = useAppDispatch();
    const device = devices[props.device_id];
    if (device == undefined) {
        return null;
    }
    const s = device_states[props.device_id];
    const state = isTransmitterDeviceState(s) ? s['state'] : undefined;
    let s1, s2, s3;
    if (state == 'up') {
        s1 = 'off';
        s2 = undefined;
        s3 = undefined;
    }
    else if (state == 'stop' || state == undefined) {
        s1 = undefined;
        s2 = 'off';
        s3 = undefined;
    }
    else if (state == 'down') {
        s1 = undefined;
        s2 = undefined;
        s3 = 'on';
    }
    else {
        s1 = undefined;
        s2 = undefined;
        s3 = undefined;
    }
    // up: <span style={{'font-weight': 'bold'}}>{"\u2B06"}</span>
    // down: <span style={{'font-weight': 'bold'}}>{"\u2B07"}</span>
    return (_jsxs("div", { className: "transmitter-buttons lw-button-group", children: [_jsx(DeviceButton2, { state: s1, onClick: () => dispatch(transmitter(props.device_id, 'up')), children: _jsx(LWIcon.ArrowUp, {}) }), _jsx(DeviceButton2, { state: s2, onClick: () => dispatch(transmitter(props.device_id, 'stop')), children: _jsx(LWIcon.Stop, {}) }), _jsx(DeviceButton2, { state: s3, onClick: () => dispatch(transmitter(props.device_id, 'down')), children: _jsx(LWIcon.ArrowDown, {}) })] }));
};
